import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Modal, Button, Menu } from 'antd';
import useState2RM from '../../hooks/useState2ReduxMock';
import './FolderMoveModal.scss';
import { getParentNodeById, getTreeIdPathById, getTreeNodeById, folderId2String, folderId2Number, getChildTreeByRule, getTreeStatesByAccount, folderIdIsContact, } from '../../util';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { useAppDispatch } from '@web-common/state/createStore';
import { ModalCloseSmall } from '@web-common/components/UI/Icons/icons';
import { validateFolderOperForNode } from '../../state/customize';
import FolderTree from '../ColumnMailBox/FolderTree';
import { getIn18Text } from 'api';
const getMoveFolderTree = (tree) => {
    if (tree) {
        return getChildTreeByRule(tree, (node) => {
            if (node && (folderIdIsContact(node.entry.mailBoxId) || node.entry.mailBoxId < 0)) {
                return false;
            }
            return true;
        });
    }
    return [];
};
const MenuConfig = {
    title: getIn18Text('YIDONGZHI'),
    width: '600px',
    wrapClassName: 'folder-move-modal-warp',
    style: {
        maxHeight: '480px',
    },
};
const defaultEmptyArray = [];
const FolderMoveModal = () => {
    const dispatch = useAppDispatch();
    const [mailTreeStateMap, setTreeState] = useState2RM('mailTreeStateMap', 'doUpdateMailTreeState');
    const [folderMoveId] = useState2RM('folderMoveId', 'doUpdateFolderMoveId');
    const [folderModveModalVisiable, setFolderModveModalVisiable] = useState2RM('folderModveModalVisiable', 'doUpdateFolderModveModalVisiable');
    const [expandedMenuKeys, setExpandedMenuKeys] = useState([]);
    const [selectedMenuKeys, setSelectedMenuKeys] = useState([]);
    const [okBtnLoading, setOkBtnLoading] = useState(false);
    const folderMoveModalTree = useRef();
    const [defaultFolder, setDefaultFolder] = useState(null);
    const treeList = useMemo(() => {
        const treeState = getTreeStatesByAccount(mailTreeStateMap, folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.accountId);
        return (treeState === null || treeState === void 0 ? void 0 : treeState.mailFolderTreeList) || [];
    }, [mailTreeStateMap, folderMoveId]);
    const modalTreeList = useMemo(() => {
        return getMoveFolderTree(treeList || []);
    }, [treeList]);
    const handleNodeSelect = useCallback((node) => {
        const key = node.entry.mailBoxId;
        setSelectedMenuKeys([key]);
    }, []);
    const handleOkBtnClick = useCallback(() => {
        if (selectedMenuKeys && selectedMenuKeys.length) {
            const aimNode = getTreeNodeById(treeList, parseInt(selectedMenuKeys[0]));
            const moveNode = getTreeNodeById(treeList, folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.folderId);
            if (validateFolderOperForNode(treeList, aimNode, moveNode, false, 1)) {
                setOkBtnLoading(true);
                dispatch(Thunks.moveUserFolder([
                    {
                        id: folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.folderId,
                        parent: selectedMenuKeys[0],
                        accountId: folderMoveId.accountId,
                    },
                ]))
                    .unwrap()
                    .then(() => {
                    Message.success({
                        content: getIn18Text('YIDONGCHENGGONG'),
                    });
                    setFolderModveModalVisiable(false);
                })
                    .finally(() => {
                    setOkBtnLoading(false);
                });
            }
        }
    }, [selectedMenuKeys, treeList, folderMoveId]);
    const handleClacleBtnClick = useCallback(() => {
        setFolderModveModalVisiable(false);
        setExpandedMenuKeys([]);
        setSelectedMenuKeys([]);
    }, []);
    const handleAddFolder = useCallback(() => {
        var _a;
        const folderId = selectedMenuKeys && selectedMenuKeys[0];
        (_a = folderMoveModalTree === null || folderMoveModalTree === void 0 ? void 0 : folderMoveModalTree.current) === null || _a === void 0 ? void 0 : _a.addFolder(folderId);
    }, [selectedMenuKeys]);
    const handleExpand = useCallback(keys => {
        setExpandedMenuKeys(folderId2Number(keys));
    }, [setExpandedMenuKeys]);
    const handleMenu = useCallback(data => {
        if (data) {
            return folderMenu(data);
        }
        return React.createElement(React.Fragment, null);
    }, []);
    const handleOnAddFolder = useCallback(data => {
        return dispatch(Thunks.createUserFolder([
            {
                parent: data.entry.pid,
                name: data.entry.mailBoxName,
                accountId: data === null || data === void 0 ? void 0 : data._account,
            },
        ]))
            .unwrap()
            .then(() => true);
    }, []);
    const handleUpdateFolder = useCallback(data => {
        return dispatch(Thunks.updateUserFolder([
            {
                id: data.entry.mailBoxId,
                parent: data.entry.pid,
                name: data.entry.mailBoxName,
            },
        ])).unwrap();
    }, [dispatch]);
    const ModalFooter = useMemo(() => (React.createElement("div", { className: "folder-move-modal-footer" },
        React.createElement("div", { className: "fmmf-left" },
            React.createElement(Button, { "data-test-id": "folder-move-modal-add-folder", type: "text", className: "no-border", onClick: handleAddFolder, style: { color: 'rgba(56, 110, 231, 1)' }, disabled: okBtnLoading }, getIn18Text('XINJIANWENJIANJIA'))),
        React.createElement("div", { className: "fmmf-right" },
            React.createElement(Button, { onClick: handleClacleBtnClick }, getIn18Text('QUXIAO')),
            React.createElement(Button, { "data-test-id": "folder-move-modal-ok", type: "primary", loading: okBtnLoading, disabled: (selectedMenuKeys === null || selectedMenuKeys === void 0 ? void 0 : selectedMenuKeys.length) && defaultFolder === selectedMenuKeys[0], onClick: handleOkBtnClick }, getIn18Text('QUEDING'))))), [handleAddFolder, okBtnLoading, handleClacleBtnClick, okBtnLoading, selectedMenuKeys, defaultFolder, handleOkBtnClick]);
    const folderMenu = useCallback((node) => {
        return (React.createElement(Menu, null,
            React.createElement(Menu.Item, { key: "2", onClick: () => {
                    var _a;
                    (_a = folderMoveModalTree === null || folderMoveModalTree === void 0 ? void 0 : folderMoveModalTree.current) === null || _a === void 0 ? void 0 : _a.updateFolder();
                } }, getIn18Text('ZHONGMINGMING'))));
    }, []);
    useEffect(() => {
        if (treeList) {
            const parentNdoe = getParentNodeById(treeList, folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.folderId);
            const curNode = getTreeNodeById(treeList, folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.folderId);
            if (parentNdoe && curNode && curNode.entry && curNode.entry._deep && curNode.entry._deep > 1) {
                setSelectedMenuKeys([parentNdoe.entry.mailBoxId]);
                setDefaultFolder(parentNdoe.entry.mailBoxId);
            }
            else {
                setSelectedMenuKeys([0]);
                setDefaultFolder(null);
            }
            const nodePath = getTreeIdPathById(treeList, folderMoveId === null || folderMoveId === void 0 ? void 0 : folderMoveId.folderId);
            if (nodePath) {
                setExpandedMenuKeys(nodePath.map(item => item));
            }
        }
    }, [folderMoveId, treeList]);
    useEffect(() => {
        if (!folderModveModalVisiable) {
            setDefaultFolder(null);
        }
    }, [folderModveModalVisiable]);
    return (React.createElement(Modal, Object.assign({}, MenuConfig, { visible: folderModveModalVisiable, okText: getIn18Text('QUEDING'), cancelText: getIn18Text('QUXIAO'), maskClosable: false, closeIcon: React.createElement(ModalCloseSmall, { "data-test-id": "folder-move-modal-close" }), onCancel: () => setFolderModveModalVisiable(false), footer: ModalFooter }),
        React.createElement("div", { className: " m-tree-container m-move-tree foldermove-content-modal-warp" },
            React.createElement(FolderTree, { ref: folderMoveModalTree, editAble: true, selectedKey: selectedMenuKeys ? selectedMenuKeys[0] : defaultEmptyArray, onExpand: handleExpand, expandedKeys: folderId2String(expandedMenuKeys), data: modalTreeList, onSelect: handleNodeSelect, height: 370, unReadRender: () => React.createElement(React.Fragment, null), menu: handleMenu, onAddFolder: handleOnAddFolder, onUpdateFolder: handleUpdateFolder }))));
};
export default FolderMoveModal;
